import { render, staticRenderFns } from "./InsetText.vue?vue&type=template&id=7aa1493f&"
import script from "./InsetText.vue?vue&type=script&lang=js&"
export * from "./InsetText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports